const Images = () => {
  return (
    <>
      <h2 className="mt-5">Image and content</h2>
      <div className="row mt-5">
        <div className="col-12 col-md-4 mb-4 mb-md-0">
          <img
            src="https://dummyimage.com/400x200/000/fff"
            className="img-fluid float-start w-100"
            alt="..."
          />
        </div>
        <div className="col-12 col-md-8">
          <h3>Title</h3>
          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Possimus
            modi, quod eaque natus dolor vero inventore eos distinctio est
            iusto, nisi eius molestias fugit perferendis unde odit blanditiis
            commodi. Reiciendis.
          </p>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12 col-md-8">
          <h3>Title</h3>
          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Possimus
            modi, quod eaque natus dolor vero inventore eos distinctio est
            iusto, nisi eius molestias fugit perferendis unde odit blanditiis
            commodi. Reiciendis.
          </p>
        </div>
        <div className="col-12 col-md-4 mb-4 mb-sm-0">
          <img
            src="https://dummyimage.com/400x200/000/fff"
            className="img-fluid float-start w-100"
            alt="..."
          />
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-12 mb-5">
          <h2>Responsive Image</h2>
          <img
            src="https://dummyimage.com/1076x400/000/fff"
            className="img-fluid"
            alt="..."
          />
          <p className="mt-3">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Amet enim
            soluta eveniet ipsa consequuntur commodi suscipit et quod. Beatae
            rerum quam commodi sed. Expedita modi fugit culpa. Atque, hic non.
          </p>
        </div>
      </div>
      <h2>Image caption</h2>
      <div className="row mb-3">
        <div className="col-12">
          <figure className="figure">
            <img
              src="https://dummyimage.com/1076x400/000/fff"
              className="figure-img img-fluid"
              alt=""
            />
            <figcaption className="figure-caption">
              A caption example for the image.
            </figcaption>
          </figure>
        </div>
      </div>
      <h2>Image left/right</h2>
      <div className="row">
        <div className="col-12">
          <img
            src="https://dummyimage.com/400x200/000/fff"
            className="img-fluid float-start mb-5 mb-sm-0"
            alt="..."
          />
          <img
            src="https://dummyimage.com/400x200/000/fff"
            className="img-fluid float-end"
            alt="..."
          />
        </div>
      </div>
    </>
  );
};

export default Images;
